import { render, staticRenderFns } from "./JettonInfo.vue?vue&type=template&id=12480177"
import script from "./JettonInfo.vue?vue&type=script&lang=js"
export * from "./JettonInfo.vue?vue&type=script&lang=js"
import style0 from "./JettonInfo.vue?vue&type=style&index=0&id=12480177&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports